import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import PreviewCustomerApproval from "./PreviewCustomerApproval";

const CustomerApprovalUpdate = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [step, setStep] = useState(1);
  const [sra, setSra] = useState();
  const [fileNames, setFileNames] = useState({
    attachment1Filename: "",
    attachment2Filename: "",
    attachment3Filename: "",
  });
  const [fetching, setFetching] = useState(false);
  const { sraId } = useParams();
  const location = useLocation();
  const [noOfApprovers, setNoOfApprovers] = useState();
  const [approvers, setApprovers] = useState({
    approver1: "",
    approver2: "",
    approver3: "",
    approver4: "",
  });
  const [data, setData] = useState();

  const getSRA = async () => {
    setFetching(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/customer-approval/by-id?sraId=${sraId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setSra(res.data);
      setNoOfApprovers(res.data.numberOfApprovers);
      setFileNames({
        ...fileNames,
        attachment1Filename: res.data.attachment1Filename || "",
        attachment2Filename: res.data.attachment2Filename || "",
        attachment3Filename: res.data.attachment3Filename || "",
      });
    } catch (error) {
      console.log(error);
    } finally {
      setFetching(false);
    }
  };
  useEffect(() => {
    getSRA();
  }, []);

  return (
    <div style={{ position: "relative" }}>
      {fetching && <div className="loading-div"></div>}
      {step === 1 && (
        <Step1
          sra={sra}
          setSra={setSra}
          setStep={setStep}
          fileNames={fileNames}
          setFileNames={setFileNames}
          storedUser={storedUser}
        />
      )}
      {step === 2 && (
        <Step2
          sra={sra}
          setSra={setSra}
          setStep={setStep}
          storedUser={storedUser}
        />
      )}
      {step === 3 && (
        <Step3
          sra={sra}
          setSra={setSra}
          setStep={setStep}
          storedUser={storedUser}
          fileNames={fileNames}
          setFileNames={setFileNames}
        />
      )}
      {step === 4 && (
        <Step4
          sra={sra}
          setSra={setSra}
          approvers={approvers}
          setApprovers={setApprovers}
          noOfApprovers={noOfApprovers}
          setNoOfApprovers={setNoOfApprovers}
          setStep={setStep}
          storedUser={storedUser}
        />
      )}

      {step === 5 && (
        <PreviewCustomerApproval
          sra={sra}
          approvers={approvers}
          setStep={setStep}
          storedUser={storedUser}
          fileNames={fileNames}
          noOfApprovers={noOfApprovers}
        />
      )}
    </div>
  );
};

export default CustomerApprovalUpdate;
